<div
  class="navbar-container"
  [ngClass]="{
    light: globalService.theme() === 'light',
    dark: globalService.theme() === 'dark',
  }"
  [style.height.px]="globalService.navbarHeight()"
>
  <div class="flex flex-center col-gap-15">
    <img class="logo" src="../../../assets/dark/APA_Logo.svg" alt="APA_Logo" />
    <h3 class="title">Sequence History</h3>
  </div>
  <div class="flex flex-center">
    <i class="theme-icon pi pi-bars" (click)="menu.toggle($event)"></i>
    <p-tieredMenu #menu [model]="items" [popup]="true" />
  </div>
</div>
